import { Injectable } from '@angular/core';
import { map, Observable } from 'rxjs';
import { SendMessageForm } from 'src/app/shared/interfaces';

import { Constants } from '../../common';
import { BaseAPI } from './base-api';

@Injectable({
  providedIn: 'root',
})
export class SendMessageApi {
  constructor(private baseAPI: BaseAPI) {}

  sendMessage(form: SendMessageForm): Observable<string> {
    return this.baseAPI.post(Constants.NEW_SEND_MESSAGE_API_URL, form).pipe(
      map((res) => {
        return res.message;
      })
    );
  }
}
